import { useState } from "react";
import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../../helpers";
import { useGetUserList } from "../../../../hooks/api/queries/useSettings";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";
import { useGetOrderList } from "../../../../hooks/api/queries/useOrder";

export const useSalesTransactions = ({ isUserListEnabled = true }) => {
  const queries = getUrlQuerysection();
  const {
    search,
    setSearch,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByDate,
    filterByKey,
  } = useUrlSearch();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [isModal, setIsModal] = useState({
    isEndOfDay: search.get("endOfDay") ? true : false,
    isReturn: false,
  });
  const [props, setProps] = useState({
    headerTitle: "End of Day",
    headerDescription:
      "You can customize how you want to receive your end of day with the options below",
    hasPrevNavigation: false,
    routeToPrev: null,
  });

  const { data: userList, isLoading: isLoadingUsers } =
    useGetUserList(isUserListEnabled);

  const {
    isLoading: isFetchingSalesTransactions,
    data: salesTransactions,
    refetch: handleFetchSalesTransactions,
  } = useGetOrderList({ queries, isEnabled: true });

  const filterReturnStatus = (value) => {
    filterByKey("return_status", value);
  };

  const filterByInitiator = (value) => {
    filterByKey("initiator_id", value);
  };

  const filterByStoreType = (value) => {
    filterByKey("order_source", value);
    filterByKey("unsynced", "");
  };

  const filterByStatus = (value) => {
    filterByKey("status", value);
    filterByKey("unsynced", "");
  };

  const filterByUnsynced = (value) => {
    filterByKey("order_source", "INTERNAL");
    filterByKey("unsynced", value);
  };

  return {
    isFetchingSalesTransactions,
    storeList,
    metaDetails: salesTransactions?.meta || {},
    salesTransactions: salesTransactions?.data || [],
    search,
    userList: userList || [],
    isLoadingUsers,
    isModal,
    props,
    setProps,
    setSearch,
    filterBySearch,
    filterByDate,
    setIsModal,
    filterByInitiator,
    handleFetchSalesTransactions,
    filterByStoreId,
    filterByStoreType,
    filterByStatus,
    gotoPage,
    filterReturnStatus,
    filterByUnsynced,
  };
};
